import { Pipe, PipeTransform } from '@angular/core';
import { ADMISSION_REQUEST_STATUS, ADMISSION_REQUEST_STATUS_BG, ADMISSION_REQUEST_STATUS_COLOR } from 'src/app/core/constants/admission-request-status.enum';
import { TranslateService } from 'src/app/core/translate';

@Pipe({
    name: 'getAdmissionStatus'
})
export class GetAdmissionStatusPipe implements PipeTransform {
    public constructor(private translateService: TranslateService) {}
    public transform(requestStatus: string): { txt: string; color: string; bg: string } {
        if (requestStatus) {
            return {
                txt: this.translateService.instant(ADMISSION_REQUEST_STATUS[requestStatus]),
                color: ADMISSION_REQUEST_STATUS_COLOR[requestStatus],
                bg: ADMISSION_REQUEST_STATUS_BG[requestStatus]
            };
        }
        return {
            txt: 'N/A',
            color: 'gray',
            bg: 'black'
        };
    }
}
